export const BELOW = "below";
export const SIDE = "side";
